import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

type Props = {
  emittedEventDefs: any[];
  maxHeight?: number;
};

const EmittedEventDefsView = ({ emittedEventDefs = [] }: Props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Emitted Events
        </Typography>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', fontWeight: 700 }}>
                  Event Name
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', fontWeight: 700 }}>
                  Event Label
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', fontWeight: 700 }}>
                  Event Type
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(emittedEventDefs || []).map((emittedEventDef: any, idx: any) => {
                return (
                  <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={idx}>
                    <TableCell>{emittedEventDef.eventName}</TableCell>
                    <TableCell>{emittedEventDef.eventLabel}</TableCell>
                    <TableCell>{emittedEventDef.eventType}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default EmittedEventDefsView;
